/* eslint-disable jira/filename-case */
import { expVal } from '@atlassian/jira-feature-experiments';

export default {
	get(): boolean {
		return expVal('saved_list_view', 'isEnabled', false);
	},
};
